<div class="flex flex-column align-items-center justify-content-center">
  <h3 class="text-center mb-3">
    Scopri chi sono i <span class="green">Tour Leader</span> che organizzano i
    viaggi!<img class="ml-2" src="/assets/media/icons/tour-guide.png" />
  </h3>
  <span class="text-center grey-text"
    >Viaggiatori appassionati con esperienza sul campo, pronti a guidarti in
    ogni tappa dell'avventura. La loro presenza è garanzia di entusiasmo,
    sicurezza e coinvolgimento totale. Che tu stia partendo per la prima volta o
    sia un esploratore esperto, i Tour Leader sapranno trasformare ogni momento
    in un ricordo indimenticabile.</span
  >
</div>
<!-- <div class="mt-6">
  <p-carousel
    [value]="leaders"
    [numVisible]="4"
    [numScroll]="1"
    [responsiveOptions]="responsiveOptions"
    [showNavigators]="false"
  >
    <ng-template let-l pTemplate="item">
      <div class="card-guide h-full" (click)="goTo(l)">
        @if(l.related_registry && l.role.id === enumUserRole.TOURLEADER_PRO){
        <div class="pro-badge" pTooltip="Tour Leader Pro" tooltipPosition="top">
          <i class="pi pi-crown"></i>
        </div>
        } @if(l.related_registry && l.role.id === enumUserRole.TOURLEADER_PRO){
        <a class="profile-img-container">
          <div
            class="guide-img"
            [ngStyle]="{
              'background-image':
                'url(' +
                (l.related_registry.logo | imagePipe : 'registry_card' : 'md') +
                ')'
            }"
          ></div>
        </a>
        }@else{
        <a class="profile-img-container">
          <div
            class="guide-img"
            [ngStyle]="{
              'background-image':
                'url(' +
                (l.profile_picture | imagePipe : 'user-grey-bg' : 'md') +
                ')'
            }"
          ></div>
        </a>
        }
        <a class="profile-container">
          <div class="guide-info flex align-items-center gap-2">
            @if(l.related_registry && l.role.id ===
            enumUserRole.TOURLEADER_PRO){
            <h3 class="m-0">{{ l.related_registry.name }}</h3>
            }@else { @if(l.page_name && l.role.id === enumUserRole.TOURLEADER){
            <div class="flex flex-column">
              <h3 class="m-0">{{ l.page_name }}</h3>
              @if(l.name){
              <small class="my-1"
                >{{ l.name | titlecase }} {{ l.last_name | titlecase }}</small
              >
              }@else {
              <small class="my-1">{{ l.username }}</small>
              }
            </div>
            }@else { @if(l.name){
            <h3 class="m-0">
              {{ l.name | titlecase }} {{ l.last_name | titlecase }}
            </h3>
            }@else {
            <h3 class="m-0">{{ l.username }}</h3>
            } } }
          </div>
          <div class="grey-text">
            <div class="grey-text">
              <div class="notes-container">
                @if(l.related_registry && l.role.id ===
                enumUserRole.TOURLEADER_PRO){
                <small>{{
                  l.related_registry.notes || "Viaggiamo insieme!"
                }}</small>
                }@else {
                <small>{{ l.notes || "Viaggiamo insieme!" }}</small>
                }
              </div>
              <div class="flex align-items-center gap-2 my-3">
                <i class="pi pi-globe"></i>
                @if(l.country){
                <small>{{ l.country.name }}</small>
                }@else {
                <small>-</small>
                }
              </div>
              <div class="flex align-items-center gap-2">
                <i class="pi pi-map"></i>
                <small>{{ l.organized_travels || 0 }} viaggi organizzati</small>
              </div>
            </div>
          </div>
        </a>
      </div>
    </ng-template>
  </p-carousel>
</div> -->
<div
  class="flex justify-content-center mt-4 mb-5"
  routerLink="/tour-leader/leaders-list"
>
  <a class="more">
    <span> Scopri i nostri Tour Leader </span>
    <i class="pi pi-arrow-circle-right"></i>
  </a>
</div>
<hr />
